export const DIFFICULTY_TO_SIZE = {
  easy: 3,
  medium: 4,
  hard: 5
}

export const ALLOWED_DIFFS = new Set(Object.keys(DIFFICULTY_TO_SIZE))

export const PUZZLE_IMAGE_PATHS = {
  cover: '/puzzle/cover/puzzle-cover.webp',
  dailyBase: '/puzzle/daily',
  fallback: '/puzzle/fallback/puzzle-fallback-01.webp'

  // Future: daily, weekly, campaign-specific, etc.
}

export const PUZZLE_METADATA_CONFIG = {
  imageDescriptionNamespace: 'puzzle.images',
  fallbackKey: 'default'
}

export const PUZZLE_TIMINGS = {
  victorySound: 800, // ms
  endScreenTransition: 2800, // ms
  overlayFadeDuration: 1200, // ms
  celebrationStart: 800 // ms
}
